<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Profil</h3>
                </div>
            </div>
        </div>
        <tabs fill class="flex-column flex-md-row">
            <card shadow>
                <tab-pane title="Profil editiern">
                    <template>
                        <form @submit.prevent="editProfile($route.params.id)">
                            <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                            <h6 class="heading-small text-muted mb-4">Angaben zum Profil</h6>
                            <profileform ref="PForm" :edit="true"></profileform>
                            <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                                <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">Profil ändern</span></button>
                        </form>
                    </template>
                </tab-pane>

                <tab-pane title="Dokumente">
                    <template>
                        <div class="row mb-3">
                            <div class="col text-right">
                                <base-button slot="title" size="sm" type="secondary" v-on:click="$router.push('/users/profiles_document_create/'+$route.params.id)" icon="ni ni-fat-add">
                                    Dokument hinzufügen
                                </base-button>
                            </div>
                        </div>
                        <div class="row>">
                            <div class="col">
                                <profile-document-table :profile="$route.params.id"></profile-document-table>
                            </div>
                        </div>
                    </template>
                </tab-pane>
            </card>
        </tabs>
    </card>
</template>

<script>
    import Profileform from "@/views/Profiles/Details/profileform";
    import ProfileDocumentTable from "@/views/ProfileDocuments/table";
    export default {
        name:"edit",
        components:{ProfileDocumentTable,  Profileform},
        data() {
            return {
                isLoading: false,
                file: '',
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.showProfile(this.$route.params.id)
        },
        methods: {
        showProfile(id) {
            return new Promise(() => {
                const header = this.authHeader();
                header['Content-Type'] = 'application/json';
                const requestOptions = {
                    method: 'GET',
                    headers: header,
                };
                this.isLoading = true;
                fetch(process.env.VUE_APP_API_SERVER + `/api/profiles/`+id, requestOptions)
                    .then(this.handleResponse)
                    .then(response => {

                            this.isLoading = false;
                            this.$refs.PForm.profile = response;
                            this.$refs.PForm.customer = response.user.customer;
                            this.$refs.PForm.profile.user = response.user['@id'];

                            //if (typeof response.state !== 'undefined') this.$refs.LForm.location.state = response.state['@id'];
                            //if (typeof response.customer !== 'undefined') this.$refs.LForm.location.customer = response.customer['@id'];
                        },
                        error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        });
            });
        },
        editProfile(id) {
            return new Promise(() => {
                const header = this.authHeader();
                header['Content-Type'] = 'application/merge-patch+json';
                let senddata = this.$refs.PForm.profile;
                const requestOptions = {
                    method: 'PATCH',
                    headers: header,
                    body: JSON.stringify(senddata)
                };
                this.isLoading = true;
                fetch(process.env.VUE_APP_API_SERVER + `/api/profiles/`+id, requestOptions)
                    .then(this.handleResponse)
                    .then(response => {
                            this.isLoading = false;
                            this.status =  {type: 'success', msg: 'Profil '+response.name+' (ID: '+response.id+') wurde editiert.'};
                        },
                        error => {
                            this.isLoading = false;
                            this.status =  {type: 'danger', msg: error};
                        });
            });
        },
        isAdmin() {
            return this.$store.getters['authentication/isAdmin'];
        }
        }
    }
</script>

<style scoped>

</style>